import { reflectionSummarySchema, reflectionsResponseSchema } from "../schemas/reflections";
import { fetchApi } from "./internal";

export const reflections = {
	listForEvent: (clubId: string, eventId: string) =>
		fetchApi(`/clubs/${clubId}/events/${eventId}/reflections`, reflectionsResponseSchema),
	summaryForEvent: (clubId: string, eventId: string) =>
		fetchApi(`/clubs/${clubId}/events/${eventId}/reflections/summary`, reflectionSummarySchema),
};
